import {ValentineBanner} from "../../features/bouquets/ui/ValentineBanner";
import {FlowerServices} from "../../features/bouquets/ui/FlowerServices/FlowerServices";
import {Contacts} from "../../shared/ui/Contacts";
import {MarchBanner} from "../../features/orders/ui/MarchBanner";
import {useSEO} from "../../shared/ui/SEOHead";
import './HomePage.css';
import {useEffect, useState} from "react";

export function HomePage() {
    useSEO({
        title: "Цветочный магазин «Ваниль» — цветы и букеты в Булгаково и Уфе",
        description: "Свежие цветы, готовые и авторские букеты с быстрой доставкой по Уфе и Булгаково. Заказ онлайн, сборка по фото, гарантия свежести.",
        canonicalUrl: "https://vanilufa.ru/"
    });

    const [valentineVisible, setValentineVisible] = useState(false);

    useEffect(() => {
        const now = new Date();
        const currentYear = now.getFullYear();
        const notValentineDay = new Date(currentYear, 1, 16) // 16 февраля текущего года (Пусть 15го еще повисит баннер)
        setValentineVisible((notValentineDay.getTime() - now.getTime()) > 0);
    }, []);

    return (
        <div className="home-page">
            <h1>Цветочный магазин «Ваниль» — Булгаково и Уфа</h1>
            <p>
                Свежие цветы и авторские букеты в селе Булгаково и городе Уфа. У нас вы можете
                купить цветы для любого повода, заказать букет по фото и оформить доставку по Булгаково и Уфе.
            </p>
            <MarchBanner/>
            {valentineVisible && ( <ValentineBanner/>) }
            {/*todo types bouquets*/}
            <FlowerServices/>
            <Contacts />
        </div>
    );
}